// The width the site's line actually draws at, as --line-drawn on <html>.
//
// --line-width is 1.5px, and browsers snap a border to the pixel grid their own
// way (Chrome floors it to 1px; Safari rounds it to device pixels). An SVG
// stroke or a gradient bar isn't snapped, so at a true 1.5px an icon read
// heavier than the borders around it. Icons draw at --line-drawn instead: the
// border's own width, measured. It falls back to --line-width (_config.scss)
// until this runs, and is measured again when the screen density changes
// (zoom, or a window moved to another display).

// Runs before the app mounts, so it must never throw: anything unsupported
// leaves --line-drawn at its CSS fallback.
export function syncLineWidth(): void {
  try {
    measure();
  } catch {
    // Keep the fallback.
  }
}

function measure(): void {
  const probe = document.createElement('div');
  probe.style.cssText =
    'position:absolute;visibility:hidden;pointer-events:none;border-top:var(--line-width) solid;';
  document.body.appendChild(probe);
  const drawn = getComputedStyle(probe).borderTopWidth;
  probe.remove();
  if (drawn && drawn !== '0px') {
    document.documentElement.style.setProperty('--line-drawn', drawn);
  }

  // Measure again when the screen density changes. Older Safari has only
  // addListener, and some browsers don't know `resolution` at all; either way
  // the first measurement stands.
  const density = window.matchMedia?.(`(resolution: ${window.devicePixelRatio}dppx)`);
  if (density?.addEventListener) {
    density.addEventListener('change', syncLineWidth, { once: true });
  } else if (density?.addListener) {
    density.addListener(syncLineWidth);
  }
}
